export default __webpack_public_path__ + "static/media/left.f7448bd9.svg";